import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ModalType, PasswordStatus, TempAlertPosition, TempAlertType } from '../enum/EnumRepository';
import { useAuth } from './useApi/useAuth';
import { useTempAlertStore } from '../store/portal/tempAlertStore';
import { getTempAlertMessage } from '../constants/tempAlertMessages';
import { useModalStore } from '../store/portal/modalStore';


export const usePasswordStatusCheck = () => {
  const { setTempAlert, clearTempAlert } = useTempAlertStore();
  const { pathname } = useLocation();
  const { user, isOwner } = useAuth();
  const { setStandardModal } = useModalStore();

  // 비밀번호 설정 안되어 있을 때 경고 띄우기
  useEffect(() => {
    if (user == null || !isOwner) return;
    if (user.passwordStatus === PasswordStatus.NOT_SET) {
      setTempAlert({
        type: TempAlertType.PW_NOT_SET,
        position: TempAlertPosition.RT,
        content: getTempAlertMessage('PASSWORD_NOT_SET'),
        duration: 5000,
        onClick: () => {
          setStandardModal({
            modalType: ModalType.SET_PW,
            title: "Set Password",
            value: null,
            handleChange: () => { }
          });
          clearTempAlert();
        }
      });
    }
  }, [user, pathname, isOwner]);
}